import React, { useRef, useState } from 'react'
import { useApplicationContext } from '../../contexts/appContext'
import { ErrorDialog, LoadingDialog, Header, Layout } from '@verifier-user/verifier-cdr'
import { EastVenturesCancel } from './EastVenturesCancel'
import { EnergyCancel } from './EnergyCancel'
import { IncomeCancel } from './IncomeCancel'
import { BavCancel } from './BavCancel'

export const Cancel = () => {
  const [error, setError] = useState(null)
  const [errorShown, setErrorShown] = useState(false)
  const [processing, setProcessing] = useState(false)
  const containerRef = useRef(null)
  const currentErrorRef = useRef(null)

  const { vendorSettings, vendorData, logout } = useApplicationContext()

  const components = {
    EastVenturesCancel,
    IncomeCancel,
    EnergyCancel,
    BavCancel
  }

  const getCancelComponent = () => {
    const CancelComponent = components[vendorData.cancelComponent]
    return (
      <CancelComponent
        currentErrorRef={currentErrorRef}
        setProcessing={setProcessing}
        setError={setError}
        setErrorShown={setErrorShown}
      />
    )
  }

  return (
    <>
      <Header vendorSettings={vendorSettings} />
      <Layout
        vendorSettings={vendorSettings}
        isAuthenticated={() => {
          return false
        }}
        logout={logout}
      >
        <div ref={containerRef}>
          <LoadingDialog id={'fnf-cancel'} isOpen={processing} />

          <ErrorDialog
            id='cancelDialog'
            error={error}
            open={errorShown}
            setOpen={setErrorShown}
            cancelHandler={currentErrorRef.current && currentErrorRef.current.cancelFunction}
            okTitle={
              currentErrorRef.current && currentErrorRef.current.okTitle ? currentErrorRef.current.okTitle : 'Ok'
            }
            cancelTitle={
              currentErrorRef.current && currentErrorRef.current.cancelTitle
                ? currentErrorRef.current.cancelTitle
                : 'Cancel'
            }
            retryHandler={currentErrorRef.current ? currentErrorRef.current.retryFunction : undefined}
          />

          {getCancelComponent()}
        </div>
      </Layout>
    </>
  )
}
